import * as React from 'react'
import type { SVGProps } from 'react'
const MagnifyingGlass = (props: SVGProps<SVGSVGElement>) => (
<svg {...props} width={props.width ?? '64'} height={props.height ?? '64'} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.2" d="M28 48C39.0457 48 48 39.0457 48 28C48 16.9543 39.0457 8 28 8C16.9543 8 8 16.9543 8 28C8 39.0457 16.9543 48 28 48Z" fill="#002A73"/>
<path d="M28 48C39.0457 48 48 39.0457 48 28C48 16.9543 39.0457 8 28 8C16.9543 8 8 16.9543 8 28C8 39.0457 16.9543 48 28 48Z" stroke="#002A73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M42.1426 42.1426L56.0001 56.0001" stroke="#002A73" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

)
export default MagnifyingGlass